import { useFlipperFlag } from './useFlipperFlag'
import { useIsOnboardingRedesign } from './useIsOnboardingRedesign'

/**
 * Quick hook for onboarding content plan v2 flag detection
 */
export const useOnboardingContentPlanV2 = () => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const hasContentPlanV2 = useFlipperFlag('onboarding_content_plan_v2')
  return isOnboardingRedesign && hasContentPlanV2
}
